import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  deleteApplicantFailed,
  deleteApplicantSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* deleteApplicant(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/applicants/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteApplicantSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteApplicantFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteApplicantFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
